// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-image-gap[data-v-76d15635] {
  width: 28px;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/leasingOffers/VehicleTechs.vue","webpack://./VehicleTechs.vue"],"names":[],"mappings":"AACA;EACE,WAAA;ACAF","sourcesContent":["\r\n.no-image-gap {\r\n  width: 28px;\r\n}\r\n",".no-image-gap {\n  width: 28px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
